import React from 'react';
import { useInView } from '@/hooks/useInView';

export function Reveal({ as: As = 'div', delay = 0, className = '', children, ...rest }) {
  const [ref, inView] = useInView();
  return (
    <As
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`reveal-blur ${inView ? 'in-view' : ''} ${className}`}
      {...rest}
    >
      {children}
    </As>
  );
}

export function RevealStagger({ children, gap = 70, className = '' }) {
  const arr = React.Children.toArray(children);
  return (
    <div className={className}>
      {arr.map((child, i) => (
        <Reveal key={i} delay={i * gap}>{child}</Reveal>
      ))}
    </div>
  );
}

/** Image frame that opens from an inset clip-path when scrolled into view. */
export function ClipReveal({ as: As = 'div', className = '', children, ...rest }) {
  const [ref, inView] = useInView({ threshold: 0.1 });
  return (
    <As ref={ref} className={`nd-clip ${inView ? 'in-view' : ''} ${className}`} {...rest}>
      {children}
    </As>
  );
}
